/** #272 / #895 — playUri timeout verify (UPnP or exclusive engine). */

import { isLocalNativeRendererId } from './localNativeRenderer';
import { verifyExclusiveEnginePlaying } from './localNativePlaybackVerify';

/** After a playUri command timeout, treat renderer PLAYING/TRANSITIONING as success. */
export async function verifyRendererPlayingAfterTimeout(
  getTransportInfo: (rendererId: string) => Promise<string>,
  rendererId?: string | null,
): Promise<boolean> {
  if (!rendererId) return false;
  const [{ getPlayUriPendingSession, hasPlayUriAcceptanceEvidence, shouldRetainQueueTransportOwnership }, { probePlayUriPendingSession }, { recentExclusiveTimeoutProbe }] =
    await Promise.all([import('./playUriConfirmation'), import('./playUriPendingProbe'), import('./exclusiveTimeoutFallback')]); // lazy: connector.ts re-exports this module

  if (isLocalNativeRendererId(rendererId)) { const probed = recentExclusiveTimeoutProbe(); if (probed !== null) return probed; // #10426-a1 fresh dispatch probe
    const session = getPlayUriPendingSession();
    if (session && session.rendererId === rendererId) {
      if (hasPlayUriAcceptanceEvidence(session)) return true;
      const outcome = await probePlayUriPendingSession(getTransportInfo, session);
      return outcome === 'success' || outcome === 'pending';
    }
    if (shouldRetainQueueTransportOwnership()) return true;
    return verifyExclusiveEnginePlaying();
  }

  const session = getPlayUriPendingSession();
  if (session && session.rendererId === rendererId) {
    const outcome = await probePlayUriPendingSession(getTransportInfo, session);
    return outcome === 'success' || outcome === 'pending' || hasPlayUriAcceptanceEvidence(session);
  }
  try {
    const raw = await getTransportInfo(rendererId);
    const upper = String(raw || '').toUpperCase();
    return upper.includes('PLAYING') || upper.includes('TRANSITIONING');
  } catch {
    return false;
  }
}
